export enum LogLevel {
  ERROR = "error",
  WARN = "warn",
  INFO = "info",
  DEBUG = "debug",
}

export enum LogCategory {
  FILE_OPS = "FILE_OPS",
  STATE = "STATE",
  RENDER = "RENDER",
  IPC = "IPC",
  UI = "UI",
  PERFORMANCE = "PERFORMANCE",
  LIFECYCLE = "LIFECYCLE",
  PLAYBACK = "PLAYBACK", // Audio playback, cursor positioning, time mapping
  AUDIO = "AUDIO", // Audio service operations
}

export interface LogEntry {
  timestamp?: string;
  level: LogLevel;
  category: LogCategory;
  operation: string;
  message: string;
  context?: Record<string, unknown>;
  error?: {
    message: string;
    stack?: string;
    code?: string;
  };
  duration?: number;
  sessionId?: string;
}
